import * as productCollectionApi from '@apis/product-collection';
import { ProductCollection } from '@models/productCollection';
import { useQuery } from '@tanstack/react-query';
import { Button, Input, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { RowSelectionType } from 'antd/es/table/interface';
import React, { useState } from 'react';

const SelectProductCollectionModal: React.FC<{
  open: boolean;
  onClose: () => void;
  onAddCollections: (collections: ProductCollection[]) => void;
  existingIds?: string[];
}> = ({ open, onClose, onAddCollections, existingIds = [] }) => {
  const [searchQuery, setSearchQuery] = useState({ page: 0, size: 10, keyword: '' });
  const [selectedRows, setSelectedRows] = useState<ProductCollection[]>([]);

  const { data: searchResult, isLoading } = useQuery({
    queryKey: ['admin-search-product-collections-modal', searchQuery],
    queryFn: () => productCollectionApi.searchProductCollections(searchQuery),
    select: (res) => res.data,
  });

  const handleAdd = () => {
    onAddCollections(selectedRows);
    setSelectedRows([]);
    onClose();
  };

  const columns: ColumnsType<ProductCollection> = [
    {
      title: 'ID',
      dataIndex: '_id',
      width: 150,
    },
    {
      title: '기획전 제목',
      dataIndex: 'title',
    },
    {
      title: '타입',
      dataIndex: 'type',
      width: 100,
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: ProductCollection[]) => {
      setSelectedRows(selectedRows);
    },
    getCheckboxProps: (record: ProductCollection) => ({
      disabled: existingIds.includes(record._id),
      name: record.title,
    }),
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width="60%"
      centered
      destroyOnClose
      title="기획전 선택"
      styles={{ body: { height: '80vh', overflowY: 'auto' } }}
      footer={[
        <Button key="back" onClick={onClose}>
          취소
        </Button>,
        <Button key="submit" type="primary" onClick={handleAdd} disabled={selectedRows.length === 0}>
          추가
        </Button>,
      ]}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Input.Search
          placeholder="제목 또는 ID로 검색"
          onSearch={(value) => setSearchQuery({ ...searchQuery, keyword: value, page: 0 })}
          style={{ width: 300 }}
        />
      </div>
      <Table
        rowSelection={{
          type: 'checkbox' as RowSelectionType,
          ...rowSelection,
        }}
        columns={columns}
        dataSource={searchResult?.contents}
        loading={isLoading}
        rowKey="_id"
        pagination={{
          current: (searchResult?.page || 0) + 1,
          pageSize: searchResult?.size || 10,
          total: searchResult?.total,
          onChange: (page, pageSize) => {
            setSearchQuery({ ...searchQuery, page: page - 1, size: pageSize });
          },
        }}
      />
    </Modal>
  );
};

export default SelectProductCollectionModal;
